import { render, staticRenderFns } from "./LearnOnlyDeviceNotice.vue?vue&type=template&id=ea28b88e&scoped=true&"
import script from "./LearnOnlyDeviceNotice.vue?vue&type=script&lang=js&"
export * from "./LearnOnlyDeviceNotice.vue?vue&type=script&lang=js&"
import style0 from "./LearnOnlyDeviceNotice.vue?vue&type=style&index=0&id=ea28b88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea28b88e",
  null
  
)

export default component.exports